import {NgModule, ModuleWithProviders} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FishDatepicker, FishDatepickerNavigateEvent} from './datepicker';
import {FishDatepickerMonthView} from './datepicker-month-view';
import {FishDatepickerNavigation} from './datepicker-navigation';
import {FishInputDatepicker} from './datepicker-input';
import {FormsModule} from '@angular/forms';
import {FishDatepickerDayView} from './datepicker-day-view';
import {FishDatepickerI18n, FishDatepickerI18nDefault} from './datepicker-i18n';
import {FishCalendar, FishCalendarGregorian} from './fish-calendar';
import {FishCalendarIslamicCivil} from './hijri/fish-calendar-islamic-civil';
import {FishDateParserFormatter, FishDateISOParserFormatter} from './fish-date-parser-formatter';
import {FishDatepickerNavigationSelect} from './datepicker-navigation-select';
import {FishDatepickerConfig} from './datepicker-config';

export {FishDatepicker, FishDatepickerNavigateEvent} from './datepicker';
export {FishInputDatepicker} from './datepicker-input';
export {FishCalendar} from './fish-calendar';
export {FishCalendarIslamicCivil} from './hijri/fish-calendar-islamic-civil';
export {FishDatepickerMonthView} from './datepicker-month-view';
export {FishDatepickerDayView} from './datepicker-day-view';
export {FishDatepickerNavigation} from './datepicker-navigation';
export {FishDatepickerNavigationSelect} from './datepicker-navigation-select';
export {FishDatepickerConfig} from './datepicker-config';
export {FishDatepickerI18n} from './datepicker-i18n';
export {FishDateStruct} from './fish-date-struct';
export {FishDateParserFormatter} from './fish-date-parser-formatter';


export class FishDatepickerModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: FishDatepickerModule,
      providers: [
        {provide: FishCalendar, useClass: FishCalendarGregorian},
        {provide: FishDatepickerI18n, useClass: FishDatepickerI18nDefault},
        {provide: FishDateParserFormatter, useClass: FishDateISOParserFormatter}, FishDatepickerConfig
      ]
    };
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    FishDatepicker, FishDatepickerMonthView, FishDatepickerNavigation, FishDatepickerNavigationSelect, FishDatepickerDayView,
    FishInputDatepicker
  ],
  exports: [FishDatepicker, FishInputDatepicker],
  imports: [CommonModule, FormsModule],
  entryComponents: [FishDatepicker]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
